var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"changelog-container"},[_c('h2',[_vm._v("Change Log")]),_c('el-card',[_c('div',[_vm._v("Contenido de la vista Change Log")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }